export default __webpack_public_path__ + "static/media/hand-emoji.de58266c.png";